import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class RestaurantCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Restaurant Cleaning Gold Coast | Commercial Kitchen Cleaning"
          description="Restaurant cleaning Gold Coast. Professional commercial kitchen and dining area cleaning services."
          keywords="restaurant cleaning gold coast, commercial kitchen cleaning gold coast, hospitality cleaning gold coast, commercial cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Restaurant Cleaning Services Gold Coast
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Restaurant Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Restaurants require strict hygiene standards to
                            protect customers and comply with health
                            regulations. Our restaurant cleaning Gold Coast
                            service ensures both your kitchen and dining areas
                            are cleaned thoroughly and professionally.
                          </p>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Commercial Kitchen Cleaning
                            </h4>
                            <ul className="list-check primary">
                              <li>Degreasing surfaces and equipment</li>
                              <li>Cleaning cooking lines and exhausts</li>
                              <li>Sanitising preparation areas</li>
                              <li>Deep floor scrubbing</li>
                            </ul>
                          </div>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Dining Area Cleaning
                            </h4>
                            <p>
                              We handle table and chair sanitisation, floor
                              mopping, and comprehensive restroom cleaning to
                              ensure a pleasant atmosphere for your guests.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default RestaurantCleaningGoldCoast;
